import React from 'react';
import DealerBadgeInterface from 'interfaces/dealer-badge.interface';
import classNames from 'classnames';
import Icon from 'atomic/icon';
import { isProductRateZero } from './helpers/is-product-rate-zero';
import { shouldShowOfferBadge } from 'helpers/get-filters-offers-count';

interface RatesProps {
    offerDescription: string;
    rates: DealerBadgeInterface | undefined;
    className?: string;
}

export const RATES_ZERO: string[] = [
    'RRSO 0%',
    'Raty0%',
    'Raty 0%',
    'Raty 0 %',
    '/Raty0%/',
    '/Raty 0%/',
    '/Raty 0 %/'
];

export const RATES_PATTERN_WORDS: string[] = RATES_ZERO.concat(['Raty', '/Raty/']);

const Rates: React.FC<RatesProps> = ({ offerDescription, rates, className }) => {
    if (typeof rates !== 'undefined' && shouldShowOfferBadge(rates, offerDescription, RATES_PATTERN_WORDS)) {
        return (
            <span
                className={classNames({
                    [String(className)]: Boolean(className)
                })}
            >
                <Icon color="primary" name="database" size={14} />
                {' '}
                Raty
                {isProductRateZero(offerDescription) ? ' 0%' : ''}
            </span>
        );
    }

    return null;
};

export default Rates;
